import { useNavigate, useLocation } from "react-router-dom";
import { actionButtons, sidebarItems1 } from "../utils/data";
import useAgentData from "../utils/hooks/useAgentData";
import { useCallAction } from "../utils/context/CallActionContext";

const SidebarButton = ({ item, closeSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = location.pathname === item.path;

  return (
    <button
      onClick={() => {
        navigate(item.path);
        if (window.innerWidth < 768 && closeSidebar) {
          closeSidebar();
        }
      }}
      className={`w-full cursor-pointer h-[40px] flex items-center gap-4 px-3 ${
        isActive
          ? "border-b border-l border-white rounded-[12px]"
          : "rounded-[12px]"
      }`}
    >
      {typeof item.icon === "string" ? (
        <img src={item.icon} alt={item.label} className="h-[18px] w-[18px]" />
      ) : (
        <div className="h-[18px] w-[18px] flex items-center justify-center">
          {item.icon}
        </div>
      )}
      <span className="text-[12px] font-semibold leading-none text-white">
        {item.label}
      </span>
    </button>
  );
};

// Main Sidebar Component
const Sidebar = ({ closeSidebar }) => {
  const { agent, loading } = useAgentData();
  const { showSidebarActions, setShowSidebarActions } = useCallAction();
  const location = useLocation();

  const isDashboardPage = location.pathname === "/";

  return (
    <aside
      className={`flex flex-col ${
        isDashboardPage ? "overflow-y-auto" : ""
      } bg-black border border-black rounded-[12px] px-3`}
    >
      <div className="flex flex-col flex-grow py-3 2xl:gap-y-6 lg:gap-y-7">
        <div className="flex flex-col gap-1">
          {/* Primary Sidebar Items */}
          {sidebarItems1.slice(0, 5).map((item, index) => (
            <SidebarButton
              key={index}
              item={item}
              closeSidebar={closeSidebar}
            />
          ))}

          <span className="text-[15px] font-extralight font-inter leading-none text-[#A7A7A7] ml-[10px] mt-[20px] block">
            Workflow
          </span>

          {/* Secondary Sidebar Items */}
          {sidebarItems1.slice(5).map((item, index) => {
            const actualIndex = index + 5;
            return (
              <SidebarButton
                key={actualIndex}
                item={item}
                closeSidebar={closeSidebar}
              />
            );
          })}
        </div>

        {/* Spacer */}
        <div className="flex-grow" />

        {/* Footer Section */}
        {!loading && agent && showSidebarActions && (
          <div className="bg-black w-full rounded-b-[12px] pt-4 pb-2 px-2">
            {/* Agent Info */}
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/icons/robert.png"
                alt="User"
                className="w-[40px] h-[40px] rounded-full object-cover"
              />
              <div className="flex flex-col">
                <span className="text-[12px] font-semibold leading-[100%] text-white">
                  {agent.name}
                </span>
                <div className="flex items-center gap-x-2">
                  <img
                    src="/icons/clock.png"
                    alt="Clock"
                    className="w-[10px] h-[10px]"
                  />
                  <span className="text-[10px] text-white text-opacity-60 font-medium font-inter">
                    {agent.activeCallDuration}
                  </span>
                  <div className="w-[8px] h-[8px] rounded-full bg-[#4DFF00]" />
                  <span className="text-[10px] text-white text-opacity-60 font-medium font-inter">
                    {agent.status}
                  </span>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-between gap-2">
              {actionButtons.map((btn, i) => (
                <button
                  onClick={() => {
                    if (btn.isRed) {
                      setShowSidebarActions(false);
                    }
                  }}
                  key={i}
                  className={`flex items-center justify-center cursor-pointer w-full py-2 rounded-[8px] ${
                    btn.isRed ? "bg-[#FF3333]" : "bg-[#D9D9D9]"
                  }`}
                >
                  <img src={btn.icon} alt={btn.alt} className="w-5 h-5" />
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
